import React, { useEffect, useRef, useState } from "react";
import { observer } from "mobx-react";

import { Button } from "primereact/button";
import { DataTable } from "primereact/datatable";
import { Column } from "primereact/column";
import { Panel } from "primereact/panel";
import { InputText } from "primereact/inputtext";
import { Menu } from "primereact/menu";

import judgementStore from "../stores/judgment-store";
import {
  IntegrationImportsProps,
  JudgmentIntegration,
  IntegrationCategory,
} from "../types/JudgmentIntegrationTypes";
import JudgementClient from "../Api/judgment-client";
import judgmentStore from "../stores/judgment-store";
import { FilterMatchMode, FilterOperator } from 'primereact/api';
import appSettingsStore from "../stores/appSettings-store";

export const JudgmentsIntegrationImportsPanel: React.FC<IntegrationImportsProps> = observer(
  function (props) {
    let dt = React.useRef<DataTable>(null);
    let newMenu = React.useRef<Menu>(null);

    const [filters, setFilters] = useState(null);
    const [globalFilterValue, setGlobalFilterValue] = useState('');
    const onGlobalFilterChange = (e: any) => {
      const value = e.target.value;
      let _filters = { ...filters };
      _filters['global'].value = value;

      setFilters(_filters);
      setGlobalFilterValue(value);
    }

    const [useExternalImport, setUseExternalImport] = useState<boolean>(false);

    useEffect(() => {
      appSettingsStore.useExternalImport().then((res => {
        setUseExternalImport(res);
      }))
      .catch(e => alert('Error retreiving application settings'));
    });

    const initFilters = () => {
      setFilters({
        // @ts-ignore: 'FilterMatchMode' only refers to a type, but is being used as a value here.  TS2693
        'global': { value: null, matchMode: FilterMatchMode.CONTAINS },
        // @ts-ignore: 'FilterMatchMode' only refers to a type, but is being used as a value here.  TS2693
        'name': { operator: FilterOperator.OR, constraints: [{ value: null, matchMode: FilterMatchMode.CONTAINS }] },
        // @ts-ignore: 'FilterMatchMode' only refers to a type, but is being used as a value here.  TS2693
        'integrationCategoryName': { operator: FilterOperator.OR, constraints: [{ value: null, matchMode: FilterMatchMode.CONTAINS }] },
        // @ts-ignore: 'FilterMatchMode' only refers to a type, but is being used as a value here.  TS2693
        'statusName': { operator: FilterOperator.OR, constraints: [{ value: null, matchMode: FilterMatchMode.CONTAINS }] },
        // @ts-ignore: 'FilterMatchMode' only refers to a type, but is being used as a value here.  TS2693
        'lastUpdatedFormatted': { operator: FilterOperator.OR, constraints: [{ value: null, matchMode: FilterMatchMode.CONTAINS }] },
        // @ts-ignore: 'FilterMatchMode' only refers to a type, but is being used as a value here.  TS2693
        'lastUpdateBy': { operator: FilterOperator.OR, constraints: [{ value: null, matchMode: FilterMatchMode.CONTAINS }] },
        // @ts-ignore: 'FilterMatchMode' only refers to a type, but is being used as a value here.  TS2693
        'startDateFormatted': { operator: FilterOperator.OR, constraints: [{ value: null, matchMode: FilterMatchMode.CONTAINS }] },
        // @ts-ignore: 'FilterMatchMode' only refers to a type, but is being used as a value here.  TS2693
        'endDateFormatted': { operator: FilterOperator.OR, constraints: [{ value: null, matchMode: FilterMatchMode.CONTAINS }] },
      });
      setGlobalFilterValue('');
    }
    useEffect(() => {
      initFilters();
    }, []); // eslint-disable-line react-hooks/exhaustive-deps

    const importsActionBodyTemplate = (rowData: JudgmentIntegration) => {
      return (
        <Button
          className="p-button-sm"
          label="View"
          onClick={() => {
            viewButtonClicked(rowData.id);
          }}
        />
      );
    };

    const viewButtonClicked = async (id: number) => {
      var response = await JudgementClient.getJudgmentById(id);
      if (response.errors && response.errors.length > 0) {
        judgementStore.currentIntegration = undefined;
        props.showToast(
          "error",
          response.message ?? "",
          response.message,
          undefined,
          true
        );
      } else {
        judgementStore.setEditing(response.judgmentIntegration);
      }
    };

    const headerTemplate = () => {
      let createMenuItems = [
        {
          label: "New Judgment Import",
          command: () => {
            judgmentStore.setCreating(IntegrationCategory.Judgment as number);
          },
        },
        {
          label: "New Satisfaction Import",
          command: () => {
            judgmentStore.setCreating(IntegrationCategory.Satisfaction as number);
          },
        },
      ];

      return (
        <>
          <div className="header">
            <div className="title">Import History</div>
            <div>
              <Menu
                id="create_menu"
                model={createMenuItems}
                popup
                ref={newMenu}
              />
              <Button
                label="Create New"
                className="p-button-sm"
                icon="pi pi-angle-down"
                iconPos="right"
                onClick={(event: any) => newMenu?.current?.toggle(event)}
              />
            </div>
          </div>
        </>
      );
    };

    return (
      <>
        <Panel header={headerTemplate()}>
          <div className="p-formgrid p-grid">
            <div className="p-field p-col-12 p-md-12">
              <label htmlFor="search" className="p-mr-2">Search:</label>
              <InputText value={globalFilterValue} onChange={onGlobalFilterChange} placeholder="Keyword Search" style={{ width: "50%" }} />
            </div>
          </div>

          <DataTable
            id="jugmentsImports"
            dataKey="id"
            ref={dt}
            filters={filters}
            filterDisplay="menu"
            responsiveLayout="scroll"
            value={judgementStore.judgmentIntegrations}
            className="p-datatable-responsive p-datatable-striped p-datatable-gridlines"
            rowHover
            paginator
            showGridlines
            /*without a sortField value the datagrid doesn't display, with a valid value you can't sort the init column without sorting another first, 
            sorting works with an invalid value */
            sortField="lastUpdatedFormatted2"
            sortOrder={0}
            globalFilterFields={['name', 'integrationCategoryName', 'statusName', 'lastUpdatedFormatted', 'lastUpdateBy', 'startDateFormatted', 'endDateFormatted']}
            emptyMessage="No imports found"
            currentPageReportTemplate="Showing {first} to {last} of {totalRecords} entries"
            paginatorTemplate="FirstPageLink PrevPageLink PageLinks NextPageLink LastPageLink CurrentPageReport RowsPerPageDropdown"
            rowsPerPageOptions={[10, 25, 50, 100]}
            rows={10}
          >
            <Column
              field="name"
              header="Name"
              sortable
              filter
            />
            <Column
              field="integrationCategoryName"
              filterField="integrationCategoryName"
              header="Category"
              sortable
              filter
            />
            <Column
              field="statusName"
              filterField="statusName"
              header="Status"
              sortable
              filter
            />
            <Column
              field="lastUpdatedFormatted"
              header="Last Updated"
              sortable
              sortField="lastUpdatedFormatted"
              filter
            />
            <Column
              field="lastUpdateBy"
              header="Last Updated By"
              sortable
              filter />
            <Column
              field="startDateFormatted"
              header="Start Date"
              sortable
              style={{ maxWidth: "90px" }}
              hidden={useExternalImport == false}
            />
            <Column
              field="endDateFormatted"
              header="End Date"
              sortable
              style={{ maxWidth: "90px" }}
              hidden={useExternalImport == false}
            />
            <Column
              body={importsActionBodyTemplate}
              header=""
              headerStyle={{ width: "8em", textAlign: "center" }}
              bodyStyle={{ textAlign: "center", overflow: "visible" }}
            />
          </DataTable>
        </Panel>
      </>
    );
  }
);
